import services from '../services'
import * as types from './mutation-types'

export const getList = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_PUBLICASKINGS, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.find(id).then(res => {
    commit(types.SET_PUBLICASKING, res.data.data)
  })
}

export const replyAsking = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    commit(types.SET_PUBLICASKING, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const deleteAsking = async ({ commit }, obj) => {
  await services.deleteAsking(obj).then(res => {
    return res
  })
}
